import Testimonials from '../Components/Testimonials';
import CourseTutors from '../Components/CourseTutors';
import LearningProcess from '../Components/LearningProcess';

const FrontEndDev = () => {
  return (
    <main class="theme-blue">
        <section className="course-hero-section py-4 py-lg-5">
            <div className="container">
                <div className="row">
                    <div className="col-md-6 col-lg-7 my-3">
                        <p className="text-muted">Intermediate Level | Remote</p>
                        <h1 className="text-theme">Front-end Dev</h1>

                        <ul className="course-ul my-4">
                            <li>Live Interactive Learning</li>
                            <li>Up to 15 students per class</li>
                            <li>Hands-On Project-based Learning</li>
                            <li>18 Weeks</li>
                            <li>Lifetime Access To Techsyiq Community</li>
                            <li>Dedicated Program Support</li>
                        </ul>

                        <a href="/apply-now" className="btn btn-theme">Apply Now</a>
                    </div>
                    <div className="col-md-6 col-lg-5 my-3 ps-lg-5">
                        <img src="./img/course-hero.svg" width="100%" alt="" />
                        <span className="vector-1"></span>
                        <span className="vector-2"></span>
                        <span className="vector-3"></span>
                    </div>
                </div>
            </div>
        </section>
        <section className="bg-theme py-4 py-lg-5">
            <div className="container">
                <p className="mb-0">Begin your journey into front-end development with our React course. This course adopts a project-oriented approach, 
                allowing you to build your own project from the ground up as you progress through the HTML/CSS, JavaScript, and React framework modules. 
                Acquire the skills needed to excel in the field independently, and develop the ability to communicate effectively within the tech community and 
                with fellow developers.</p>
            </div>
        </section>
        <section className="py-4 py-lg-5">
            <div className="container">
                <h2 className="mb-4">Who is this course for?</h2>
                <div className="row">
                    <div className="col-md-4 my-3">
                        <div className="why-us-card">
                        <img src="./img/switch-careers.svg" width="100%" alt="" />
                            <h3 className="text-dark fw-400 font-noto mb-4">You are starting or switching a career</h3>
                            <p>You'd like to enter the tech world, and front-end development suits your needs the best. Or you'd like to switch to development from another tech profession to understand where to start and get some relevant knowledge.</p>
                        </div>
                    </div>
                    <div className="col-md-4 my-3">
                        <div className="why-us-card">
                        <img src="./img/dead-end.svg" width="100%" alt="" />
                            <h3 className="text-dark fw-400 font-noto mb-4">You've run into a dead-end with self-education</h3>
                            <p>You may have tried web layout, and you're following trends in development. But you'd like to gather your knowledge, advance your skills, and get feedback from industry experts.</p>
                        </div>
                    </div>
                    <div className="col-md-4 my-3">
                        <div className="why-us-card">
                        <img src="./img/pm.svg" width="100%" alt="" />
                            <h3 className="text-dark fw-400 font-noto mb-4">You're a PM, a BA, or a product owner</h3>
                            <p>You're already working in IT and aiming to understand developers better. Furthermore, you want to speak your colleagues' language, gain technical knowledge to back up your decisions, and comprehend the code.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="pb-4 pb-lg-5">
            <div className="container">
                <h2 className="mb-4">What job descriptions will fit you?</h2>

                <div className="site-card bg-theme job-description">
                    <div className="row">
                        <div className="col-2 col-lg-1">
                            <div className="job-profile">
                                <img src="./img/apple.png" alt="" />
                            </div>
                        </div>
                        <div className="col-10 col-lg-11">
                            <small>Role:</small>
                            <h3>Senior front-end developer</h3>
                        </div>
                    </div>
                    <hr className="bg-white" />
                    <h3 className="font-noto">Skills</h3>
                    <ul>
                        <div className="row gx-lg-5">
                            <div className="col-lg-4">
                                <li>Knowledge in components and styling react application layout</li>
                                <li>Experience with handling navigation with routes</li>
                                <li>Skills in react state management using Redux</li>
                                <li>Experience with building react native application with API</li>
                                <li>Experience working with web servers</li>
                            </div>
                            <div className="col-lg-4">
                                <li>Experience with Git and GitHub </li>
                                <li>Skills in using pre- and post-processors </li>
                                <li>Skills of working with basic JavaScript tools</li>
                                <li>Ability to work with console and DevTools, check the code for errors, perform debugging </li>
                                <li>Knowledge of the logic of client-server architecture when building applications</li>
                            </div>
                            <div className="col-lg-4">
                                <li>Skills in applying Advanced CSS-styles and visual effects to the layout </li>
                                <li>Experience creating responsive websites </li>
                                <li>Experience using webpack and babel</li>
                                <li>Experience with Web performance Optimization</li>
                                <li>Demonstrate expertise in creating web applications with React.js</li>
                            </div>
                        </div>
                    </ul>
                </div>
            </div>
        </section>
        <section className="py-4 theme-accordion py-lg-5">
            <div className="container">
                <h2 className="mb-4 text-center">Course Outline</h2>
                <div className="accordion-item">
                    <button className="accordion-button site-accordion collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        <span>
                            <span className="site-accordion-title">REACT</span>
                            <span className="text-theme small accordion-small">50 days <span className="mx-2">&middot;</span> 20 topics</span>
                        </span>
                    </button>
                    <div id="collapseOne" className="accordion-collapse collapse">
                    <div className="accordion-body">
                        <p>In this React course introduction, you'll embark on a journey to master the art of building dynamic and interactive user interfaces. 
                        We'll focus on React, a powerful JavaScript library widely used for creating modern web applications. 
                        Throughout this course, you'll delve into the core concepts of React, starting from understanding the fundamentals of components and state management to 
                        mastering advanced techniques for crafting responsive and efficient UIs.</p>
                        <p>On high level, we will cover the following:</p>
                        <li>Introduction to React Concepts</li>
                        <li>Components and Props</li>
                        <li>State Management</li>
                        <li>React Router</li>
                        <li>Forms and User Input</li>
                        <li>Styling in React</li>
                        <li>React Redux</li>
                    </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <button className="accordion-button site-accordion collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        <span>
                            <span className="site-accordion-title">APIs & REACT</span>
                            <span className="text-theme small accordion-small">20 days <span className="mx-2">&middot;</span> 8 topics</span>
                        </span>
                    </button>
                    <div id="collapseThree" className="accordion-collapse collapse">
                    <div className="accordion-body">
                    In this React course, you'll learn how to use APIs in your web development projects. 
                    We'll cover everything from the basics of APIs to advanced topics like integrating GraphQL and optimizing your applications. 
                    Each section is designed to be practical, so you can apply what you learn in real projects. 
                    By the end of the course, you'll have the skills to build dynamic and responsive web applications using React and APIs. 
                    It's a journey that will make you confident in working with data and creating powerful web experiences. Get ready to level up your React skills!.
                        <li>Introduction to APIs</li>
                        <li>Fetching Data in React</li>
                        <li>Working with RESTful APIs</li>
                        <li>Authentication and Authorization</li>
                        <li>GraphQL in React</li>
                        <li>Optimizing API Calls in React</li>
                    </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <button className="accordion-button site-accordion collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                        <span>
                            <span className="site-accordion-title">REACT PROJECTS</span>
                            <span className="text-theme small accordion-small">15 days <span className="mx-2">&middot;</span> 11 projects</span>
                        </span>
                    </button>
                    <div id="collapseFour" className="accordion-collapse collapse">
                    <div className="accordion-body">
                    Throughout this section, you'll not only grasp the essentials of incorporating APIs into your web development projects but also put your skills to 
                    the test by completing a total of <strong>8 minor</strong> projects and <strong>3 major</strong> projects. These hands-on projects serve as a showcase of the skill level you'll 
                    achieve by the end of the course. From mastering the basics of APIs to tackling advanced topics like GraphQL integration and application optimization, 
                    each project is tailored to reinforce your understanding and proficiency. 
                    </div>
                    </div>
                </div>
            </div>
        </section>

        <CourseTutors />
        <LearningProcess />
        <section className="pb-4 pb-lg-5">
            <div className="container">
            <h2 className="fancy-heading">Why Us?</h2>
            <div className="row mt-4 gx-lg-5">
                <div className="col-md-4 my-2">
                    <div className="why-us-card">
                        <img src="./img/FlippedClassrooms.svg" alt="Flipped classrooms" />
                        <h3>Flipped classrooms</h3>
                        <p>Study theory at home and focus on practice in live classrooms, where you’ll be guided by one of our expert tutors.</p>
                    </div>
                </div>
                <div className="col-md-4 my-2">
                    <div className="why-us-card">
                        <img src="./img/LiveClasses.svg" alt="Live classes" />
                        <h3>Live classes</h3>
                        <p>Join our Zoom classes led by industry experts — up to 15 students per className, during stand-ups.</p>
                    </div>
                </div>
                <div className="col-md-4 my-2">
                    <div className="why-us-card">
                        <img src="./img/Support.svg" alt="Support" />
                        <h3>Support</h3>
                        <p>Get the help you need to break into your new career. We provide our students with meaningful support and career guidance.</p>
                    </div>
                </div>
                <div className="col-md-4 my-2">
                    <div className="why-us-card">
                        <img src="./img/SoftSkills.svg" alt="Soft Skills" />
                        <h3>Soft Skills</h3>
                        <p>Go beyond the technical stuff. Our approach emulates a real tech working environment, where our students work in groups, guided by a team lead.</p>
                    </div>
                </div>
                <div className="col-md-4 my-2">
                    <div className="why-us-card">
                        <img src="./img/Employability.svg" alt="Employability" />
                        <h3>Employability</h3>
                        <p>Landing a job in tech can be tough — but we’ll provide you with the tools and knowledge necessary to nail your first interview.</p>
                    </div>
                </div>
                <div className="col-md-4 my-2">
                    <div className="why-us-card">
                        <img src="./img/Community.svg" alt="Community" />
                        <h3>Community</h3>
                        <p>Get access to the Techsyiq Community that comprises our alumni, a vibrant, innovative development company, and a growing network of partners.</p>
                    </div>
                </div>
            </div>
            </div>
        </section>

        <section className="testimonials testimonial-theme py-4 py-lg-5">
            <Testimonials />
        </section>

        <section className="py-4 py-lg-5 bg-pink-1">
            <div className="container">
                <h2>Tuition fees</h2>
                <p className="mb-4">Switching careers can be challenging, and we understand. We’re here to provide you with the flexibility you need.</p>
                <div className="row gx-lg-5">
                    <div className="col-md-4 my-3">
                        <div className="site-card theme-card tuition-card h-100">
                            <p className="text-muted mb-2">Full Tuition</p>
                            <h3 className="font-noto text-theme fs-3">Ksh. 21,000</h3>
                            <p className="small mb-0 text-muted">One-time full payment</p>
                        </div>
                    </div>
                    <div className="col-md-4 my-3">
                        <div className="site-card theme-card tuition-card h-100">
                            <p className="text-muted mb-2">Installments plan</p>
                            <h3 className="font-noto text-theme fs-3">Ksh. 7,500</h3>
                            <p className="small mb-0 text-muted">3 monthly payments</p>
                        </div>
                    </div>
                    <div className="col-md-4 my-3">
                        <div className="site-card theme-card tuition-card h-100">
                            <p className="text-muted mb-2">Talk to us</p>
                            <a href="/book-call" className="btn btn-outline-theme mt-4">Book a Call</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
  );
}

export default FrontEndDev;
